module.exports = __webpack_public_path__ + "static/press-banner3-a3a662d581266e39ed2ccab425c2627f.png";